import { render } from "./ManualPriorityForm.vue?vue&type=template&id=89be64f2&ts=true"
import script from "./ManualPriorityForm.vue?vue&type=script&lang=ts"
export * from "./ManualPriorityForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__